import React from 'react';

const IconPlay3: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M29.6432 11.7632C17.4025 7.03069 6.5022 8.69797 4.4842 14.3271C3.06905 18.2754 4.74724 21.9654 9.6326 24.6474C9.60348 24.6795 9.57337 24.7113 9.54558 24.7437C9.3229 25.0015 9.10055 25.2592 8.87788 25.517C8.76902 25.643 8.66645 25.7833 8.5695 25.9325C7.21523 26.9212 6.20111 28.5845 5.55689 30.7458C4.89118 32.9785 5.50098 35.6215 7.28902 37.1154C12.672 41.5825 26.1776 39.5179 35.0897 35.104C42.0281 31.6679 52.1602 21.4274 29.6432 11.7632Z" fill="#FA4B29" />
  </svg>
);

export default IconPlay3;
